import templateUrl from './dashboard-summary-table.component.html';

export const DashboardSummaryTableComponent = {
    controller: class DashboardSummaryTableComponent {
        constructor() {
            this.panelClass = "panel-default";
        }
    },
    controllerAs: "vm",
    templateUrl,
    bindings: {
        summary: "<",
        panelClass: "@",
        hideNumberCol: "<?"
    }
};
